import React from 'react';
import Loader from 'react-loader-spinner';
export const PreLoader = () => {
  return (
    <div class="loader-common">
    <Loader
      type='TailSpin'
      color='#00BFFF'
      height={60}
      width={60}
      timeout={0} //3 secs
    />
    </div>
  );
};
